import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { pickBy } from 'lodash';

import Icon, { GLYPHS } from './icon';

class FormSection extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  }

  static childContextTypes = {
    setValidationError: PropTypes.func,
  };

  state = {
    expanded: false,
    validationErrors: {},
  };

  getChildContext() {
    return { setValidationError: this.setValidationError };
  }

  setValidationError = (key, error) => {
    this.setState({
      validationErrors: pickBy({ ...this.state.validationErrors, [key]: error }),
    });
  };

  getErrorCount() {
    return Object.keys(this.state.validationErrors).length;
  }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    return (
      <div className="c-settings-section">
        <button type="button" className="c-settings-section__header" onClick={this.toggle}>
          <div className="c-heading c-heading--lightgrey">{this.props.title}</div>
          <div className="c-badge u-ml-- u-mr-auto" display-if={this.getErrorCount()}>
            {this.getErrorCount()}
          </div>
          <div className={classnames('c-settings-section__header-icon', { 'is-active': this.state.expanded })}>
            <Icon glyph={GLYPHS.arrow} />
          </div>
        </button>
        <div className="c-settings-section__body" display-if={this.state.expanded}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default FormSection;
